let Collapse = require('../collapse');
const OrderTypeFilter = require('./order-type-filter');
const Header = require('../collapse/header');

module.exports = module.exports = {
    constructor: Collapse,
    children: [
        {
            name: 'content',
            component: OrderTypeFilter,
            watcher: {
                orderStates: ['account', 'orders', 'list', 'typeFilterData']
            }
        },
        {
            name: 'header',
            component: Header,
            props: {
                title: 'Тип заказа'
            },
            watcher: {
                isActive: ['account', 'orders', 'computed', 'list', 'selectedTypes']
            }
        }
    ]
};




// WEBPACK FOOTER //
// ./components/account/orders/orders-navigation/order-type-collapser/index.js